module.exports = __webpack_public_path__ + "static/media/chat.91bab2b8.svg";